import { ApiService } from '../../core/services/api'
import { Dialog, Question, Answer, TextAnswer, SelectableAnswer, SuggestionAnswer } from '@/modules/chatbot/controllers/Chat'

import _, { Dictionary } from 'lodash'

const DialogService = {

  list: async function (page: Number, size: Number, filters?: Dictionary<any>): Promise<Array<Dialog>> {
    let QueryParams = { 'page': page, 'page_size': size }

    if (filters) {
      _.mapKeys(filters, function (value, key) {
        QueryParams[key] = value
      })
    }

    const response = await ApiService.get('chatbot/dialog', QueryParams)

    let listSkills : Array<Dialog> = []
    for (let json of response.data.results) {
      let dialog = Dialog.fromJson(json) as Dialog

      // fromJson doesn't handle the serialization when there is a circular dependency, so we need to link in this way
      // each answer to it's question
      dialog.questions.forEach(function (question) {
        if (question.answer !== null) {
          question.answer.question = question
        }
      })

      listSkills.push(dialog)
    }
    return listSkills
  },

  sendAswers: async function (dialog: Dialog) {
    dialog.questions.forEach(function (question) {
      if (question.answer !== null) {
        question.answer.question = null
      }
    })

    const response = await ApiService.post(`chatbot/dialog/${dialog.pk}/answer/`, dialog.toJson())
    console.info('response', response)
  }

}

export { DialogService }
